export async function parseErrorMessage(res: Response, fallback: string): Promise<string> {
  const text = await res.text().catch(() => "");
  if (!text) return `${fallback} (${res.status})`;
  try {
    const data = JSON.parse(text);
    if (data && typeof data.message === "string") return data.message;
  } catch {
    // Not JSON — likely an HTML error page (e.g. GAE 413/502). Fall through.
  }
  if (res.status === 413) return "That photo is too large. Try again with a smaller image.";
  if (res.status === 502 || res.status === 503 || res.status === 504) {
    return "The server timed out processing this request. Please retry.";
  }
  return `${fallback} (${res.status})`;
}
